import React from 'react';

import PropTypes from "prop-types";

import { useWindowState } from './../../providers/WindowProvider';

const WindowContainer = ( { children } ) => {

    const [ windowState ] = useWindowState();

    return <div className={ `window-container pos-fixed cover tl-0 z-3 overflow-hidden ${ windowState.current_windows.filter( w => w.open == true ).length > 0 ? 'open' : '' }` } >
        { children }
    </div>
}

WindowContainer.propTypes = {
    children: PropTypes.oneOfType( [ PropTypes.object, PropTypes.array ] ),
}

export default WindowContainer;

